// extracted by mini-css-extract-plugin
export default {"backdrop":"AgBackdrop_backdrop__NtkGA","open":"AgBackdrop_open__sO6dO","transparent":"AgBackdrop_transparent__5YaDq"};